<template>
    <div class='civilian'>
        <div class='civilian_left'>
            <dialogCenter :productType='3' :dialogData ='alarm_detail' :deviceData ='device_data'></dialogCenter>
        </div>
        <div class='civilian_right'>
            <dialogLeft :dialogData ='mes_data' :position_item ='position_item' :productType='3'></dialogLeft>
        </div>
    </div>
</template>
<script>
import dialogCenter from './dialog_center'
import dialogLeft from './dialog_left'
export default {
    props:{
        dialogData:{
            type:Object,
            default:()=>{}
        },
    },

    data(){
        return{
            dialog_data:{},
            mes_data:{},
            device_data:{},
            pres_data:{},
            alarm_detail:{},
            position_item:[],
        }
    },
    components:{
        dialogCenter,
        dialogLeft
    },
    watch:{
        dialogData:{
            handler:function(newVal,oldVal){
                this.pageInit()
            },
            deep:true
        },
        position_item(newV){
            this.position = newV;
        },
    },
    mounted () {

    },
    computed: {

    },
    methods:{
        pageInit(){
            this.dialog_data ={};
            this.dialog_data = this.$deepClone(this.dialogData);
            this.alarm_detail = this.$deepClone(this.dialog_data.alarmDetailData);
            this.mes_data = this.$deepClone(this.dialog_data.mesData);
            this.device_data = this.$deepClone(this.dialog_data.deviceData);
            this.position_item = this.$deepClone(this.dialog_data.alarmDetailData.position);

             console.log('进入了dialog_industrial')

        },
    }

}
</script>
<style lang="less" scoped>
.civilian{
    width: 100%;

    display: flex;


    .civilian_left{
        position: absolute;
        width: 70%;
        flex: 1;
        // background: yellow;
        margin-top: 40px;
        padding-left: 70px;
    }
    .civilian_right{
        position: absolute;
        width: 40%;
        height: 85%;
        right: 0%;
        top: 14%;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/dialog/dialog_industrial.vue